import { useEffect } from 'react';
import './Skeletons.css';

const PULSE_STYLE_ID = 'raskh-skeleton-pulse-style';
// Selectors are doubled (`.skeleton-base.skeleton-base--pulse`) so the
// pulse rule always beats the base shimmer rule and any
// `[data-theme="dark"] .skeleton-base` overrides.
const PULSE_KEYFRAMES = `
@keyframes skeleton-pulse-fade {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.55; }
}
.skeleton-base.skeleton-base--pulse,
[data-theme="dark"] .skeleton-base.skeleton-base--pulse {
  background: var(--color-surface-strong);
  background-image: none;
  animation: skeleton-pulse-fade 1.6s ease-in-out infinite;
}
@media (prefers-reduced-motion: reduce) {
  .skeleton-base.skeleton-base--pulse { animation: none; opacity: 1; }
}
`;

const ensurePulseStyle = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(PULSE_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = PULSE_STYLE_ID;
  style.textContent = PULSE_KEYFRAMES;
  document.head.appendChild(style);
};

const SkeletonBase = ({
  width,
  height,
  borderRadius,
  className = '',
  style = {},
  variant,
  ...props
}) => {
  const isPulse = variant === 'pulse';

  useEffect(() => {
    if (isPulse) ensurePulseStyle();
  }, [isPulse]);

  const baseStyle = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    borderRadius: borderRadius,
    ...style,
  };

  const composedClassName = `skeleton-base${isPulse ? ' skeleton-base--pulse' : ''}${
    className ? ` ${className}` : ''
  }`;

  return (
    <div
      className={composedClassName}
      style={baseStyle}
      data-skeleton-variant={isPulse ? 'pulse' : undefined}
      aria-hidden="true"
      {...props}
    />
  );
};

export default SkeletonBase;
